import { render } from "./MdvGroups.vue?vue&type=template&id=049792de&scoped=true"
import script from "./MdvGroups.vue?vue&type=script&lang=js"
export * from "./MdvGroups.vue?vue&type=script&lang=js"

import "./MdvGroups.vue?vue&type=style&index=0&id=049792de&scoped=true&lang=css"

import exportComponent from "C:\\Users\\sciam\\Desktop\\Workspaces\\local\\workspace_vue\\mdv-webapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-049792de"]])

export default __exports__